module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/publishers/pub-categories/pub-categories.component.css
// module id = ./src/app/publishers/pub-categories/pub-categories.component.css
// module chunks = main